import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledSearchInput, StyledSearchInputContainer } from './styled';

export interface SearchProps {
  handleSearch: (search: string) => void;
}

export const Search: React.FC<SearchProps> = ({ handleSearch }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState<string>('');

  const handleSearchInputChange = (value: string) => {
    setQuery(value);
  };

  const handleSearchButtonClick = (stringQuery: string) => {
    handleSearch(stringQuery);
  };

  return (
    <StyledSearchInputContainer>
      <StyledSearchInput
        type="search"
        onChange={(event) => handleSearchInputChange(event.target.value)}
        inputChangeAction={(value) => handleSearchButtonClick(value)}
        timeoutOnInputChangeInMs={2000}
        iconClickAction={() => handleSearchButtonClick(query)}
        placeholderText={t('search.searchPlaceholder')}
        onClear={() => handleSearchInputChange('')}
      />
    </StyledSearchInputContainer>
  );
};
